import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../App/slice/selectors';
import TooltipParagraph from '../Catalog/tooltipParagraph';
import useTitleSize from 'app/components/StyledTable/useTitleSize';
import StyledTable from 'app/components/StyledTable';
import { PassengerType, PassengerTypeKey } from '../PassengerInfo/types';
import moment from 'moment';
import _ from 'lodash';
import DialogDetailPassenger from './DialogDetailPassenger';
import { IHolidayPassenger } from '../HolidayCheckout/types';
interface IPassengerInformationProps {
  dataPassenger: IHolidayPassenger[];
  countryOptions?: any[];
}
const PassengerInformation: React.FC<IPassengerInformationProps> = props => {
  const { dataPassenger, countryOptions } = props;
  const tableRef = useRef<any>();
  const translations = useSelector(selectTranslations);
  const [isShowInfo, setIsShowInfo] = useState<boolean>(false);
  const [infoPassenger, setInfoPassenger] = useState<any>(undefined);
  const passengerType = {
    [`${PassengerType.ADULT}`]: translations?.['b2b.txt.adult'],
    [`${PassengerType.CHILD}`]: translations?.['b2b.txt.child'],
    [`${PassengerType.INFANT}`]: translations?.['b2b.txt.infant'],
    [`${PassengerTypeKey.ADULT}`]: translations?.['b2b.txt.adult'],
    [`${PassengerTypeKey.CHILD}`]: translations?.['b2b.txt.child'],
    [`${PassengerTypeKey.INFANT}`]: translations?.['b2b.txt.infant'],
  };
  const titleColumnSizes = useTitleSize({
    title: [
      'b2b.txt.agent-table-order',
      'b2b.txt.passengerName',
      'b2b.txt.passengerType',
      'b2b.form.birth',
      'b2b.txt.documentType',
      'b2b.txt.guardian',
      'b2b.txt.eTicketNumber',
      'b2b.txt.viewPassengerDetails',
    ],
  });
  const onCloseDialog = () => {
    setIsShowInfo(false);
    setInfoPassenger(undefined);
  };
  const onClickSeeDetailPassenger = (item: any) => {
    setIsShowInfo(true);
    setInfoPassenger(item);
  };
  const getGuardian = (id: string | number) => {
    const passenger = dataPassenger?.find(
      el => String(el.paxId) === String(id),
    );
    if (_.isEmpty(passenger)) {
      return '-';
    }
    const name = `${passenger.title} ${passenger.lastName}/${passenger.firstName}`;
    return name;
  };
  const documentType = {
    P: 'PASSPORT',
    I: 'CCCD',
  };
  const columnTicket = [
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.agent-table-order']}
        </div>
      ),
      key: 'order',
      render: (value, _, index) => {
        const itemOrder = index + 1;
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.agent-table-order'],
            }}
          >
            {`#${itemOrder}`}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.passengerName']}
        </div>
      ),
      dataIndex: 'passengerName',
      key: 'passengerName',
      render: (text, record, index) => {
        const name = `${record.title} ${record.lastName}/${record.firstName}`;
        return (
          <TooltipParagraph
            style={{
              textAlign: 'left',
              marginBottom: 0,
            }}
            ellipsis={{ rows: 2 }}
          >
            {name}
          </TooltipParagraph>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.passengerType']}
        </div>
      ),
      dataIndex: 'passengerType',
      key: 'passengerType',
      render: (text, record, index) => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.passengerType'],
            }}
          >
            {passengerType[record?.passengerType] || '-'}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.form.birth']}
        </div>
      ),
      dataIndex: 'dateOfBirth',
      key: 'dateOfBirth',
      render: value => (
        <div
          style={{
            textAlign: 'left',
            minWidth: titleColumnSizes['b2b.form.birth'],
          }}
        >
          {value ? moment(value).format('DD/MM/YYYY') : '-'}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.documentType']}
        </div>
      ),
      dataIndex: 'documentType',
      key: 'documentType',
      render: (text, record, index) => (
        <div
          style={{
            textAlign: 'left',
            minWidth: titleColumnSizes['b2b.txt.documentType'],
          }}
        >
          {record?.document?.type ? (
            <>
              {documentType[record.document.type]} <br />
              {record.document.number || ''}
            </>
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.guardian']}
        </div>
      ),
      dataIndex: 'guardian',
      key: 'guardian',
      render: (text, record, index) => (
        <TooltipParagraph
          style={{
            minWidth: titleColumnSizes['b2b.txt.guardian'],
            maxWidth: titleColumnSizes['b2b.txt.guardian'],
            textAlign: 'left',
            marginBottom: 0,
          }}
          ellipsis={{ rows: 1 }}
        >
          {getGuardian(record.parentId)}
        </TooltipParagraph>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.eTicketNumber']}
        </div>
      ),
      dataIndex: 'eTicketNumber',
      key: 'eTicketNumber',
      render: (_, record) => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.eTicketNumber'],
            }}
          >
            {record?.listTicket?.length
              ? record?.listTicket.map((item, index) => (
                  <div key={index}>{item.number}</div>
                ))
              : '-'}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.viewPassengerDetails']}
        </div>
      ),
      dataIndex: 'action',
      key: 'action',
      render: (text, record, index) => (
        <div
          style={{
            textAlign: 'left',
            minWidth: titleColumnSizes['b2b.txt.viewPassengerDetails'],
          }}
          onClick={() => onClickSeeDetailPassenger(record)}
        >
          <div
            style={{
              border: `1px solid #E8E8E8`,
              borderRadius: 16,
              padding: '5px 10px',
              cursor: 'pointer',
              maxWidth: 'fit-content',
            }}
          >
            {translations?.['b2c.text.see-detail']}
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      <StyledTable
        tableRef={tableRef}
        dataSource={dataPassenger}
        columns={columnTicket}
        pagination={false}
        emptyText={translations?.['b2b.txt.haveNoData']}
        tableProps={{
          scroll: {
            x: dataPassenger?.length ? 'auto' : 'max-content',
            y: dataPassenger?.length ? '50vh' : undefined,
          },
        }}
        styleSlots={{
          antTableContainer: {
            overflow: 'hidden',
          },
          antTableHeader: {
            border: 'none !important',
            borderRadius: '0 !important',
          },
          tableCSS: {
            borderTopLeftRadius: !dataPassenger?.length ? '' : '0 !important',
            borderTopRightRadius: !dataPassenger?.length ? '' : '0 !important',
          },
          antTableBody: {
            paddingBottom: 10,
          },
        }}
      />
      {isShowInfo && (
        <DialogDetailPassenger
          passenger={infoPassenger || undefined}
          dataPassenger={dataPassenger}
          isShow={isShowInfo}
          onCloseDialog={onCloseDialog}
          countryOptions={countryOptions}
        />
      )}
    </>
  );
};
export default PassengerInformation;
